import React, { forwardRef, useImperativeHandle } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";

import useDirtyState from "../../../../hooks/useDirtyState";
import arrowUpIcon from "../../../../assets/images/mgsuite/Arrow_Up_Icon.svg";

const SmartSignSettingsArrow = forwardRef((props, ref) => {
  const { t } = useTranslation();
  //   {
  //   free: { angle: 90, color: "#00ff00" },
  //   occupied: { angle: 90, color: "#ff0000" }
  // }

  // const state = props.state;
  // const config = props.config[state];

  // function update(field, value) {
  //   const newConfig = {
  //     free: Object.assign({}, props.config.free),
  //     occupied: Object.assign({}, props.config.occupied),
  //   };

  //   newConfig[state][field] = value;

  //   props.onChange(newConfig);
  // }

  const state = useDirtyState(props.initialSettings);
  const link = localStorage.getItem("link");

  function channels(hex) {
    const value = hex.replace("#", "");
    return {
      r: parseInt(value.substring(0, 2), 16),
      g: parseInt(value.substring(2, 4), 16),
      b: parseInt(value.substring(4, 6), 16),
    };
  }

  async function save() {
    if (!state.hasChanges()) return;
    const freeColor = channels(state.value.free.color);
    const occupiedColor = channels(state.value.occupied.color);

    await Promise.all([
      axios.put(
        `${link}/api/ArrowDisplay/Rotation?elementId=${state.value.backendId}&configType=${state.value.free.configType}&rotation=${Number(state.value.free.angle)}`,
        null,
      ),
      axios.put(
        `${link}/api/ArrowDisplay/Color?elementId=${state.value.backendId}&configType=${state.value.free.configType}&r=${freeColor.r}&g=${freeColor.g}&b=${freeColor.b}`,
        null,
      ),
      axios.put(
        `${link}/api/ArrowDisplay/Rotation?elementId=${state.value.backendId}&configType=${state.value.occupied.configType}&rotation=${Number(state.value.occupied.angle)}`,
        null,
      ),
      axios.put(
        `${link}/api/ArrowDisplay/Color?elementId=${state.value.backendId}&configType=${state.value.occupied.configType}&r=${occupiedColor.r}&g=${occupiedColor.g}&b=${occupiedColor.b}`,
        null,
      ),
    ]);
    state.resetDirty();
  }

  function update(section, field, value) {
    const newValue = {
      ...state.value,
      [section]: {
        ...state.value[section],
        [field]: value,
      },
    };

    state.update(newValue);

    if (props.onUpdate) {
      props.onUpdate(newValue);
    }
  }

  useImperativeHandle(ref, function () {
    return {
      getSettings: state.getValue,
      hasChanges: state.hasChanges,
      resetChanges: state.resetDirty,
      isDirty: state.hasChanges,
      save,
      reset: () => state.update(props.initialSettings),
    };
  });

  function renderArrow(label, key) {
    const data = state.value[key];
    return (
      <div style={boxStyle}>
        <div style={{ display: "flex", gap: "20px" }}>
          {/* Preview */}
          <div style={previewBox}>
            <div
              role="img"
              aria-label={label}
              style={{
                transform: "rotate(" + data.angle + "deg)",
                width: "96px",
                height: "96px",
                backgroundColor: data.color,
                WebkitMask: `url(${arrowUpIcon}) center / contain no-repeat`,
                mask: `url(${arrowUpIcon}) center / contain no-repeat`,
              }}
            />
          </div>

          <div>
            <h4>{label}</h4>
            <div>
              <label style={{marginBottom: "0px"}}>{t("smartSign.angle")}</label>
              <br />
              <input
                type="number"
                value={data.angle}
                onChange={(e) => update(key, "angle", e.target.value)}
              />
            </div>

            <div style={{ marginTop: "16px" }}>
              <label style={{marginBottom: "0px"}}>{t("smartSign.color")}</label>
              <br />
              <input
                type="color"
                value={data.color}
                onChange={(e) => update(key, "color", e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="settings-groups">
      <div className="settings-name">{t("smartSign.arrowSettings")}</div>
      {renderArrow(t("smartSign.freeSymbol"), "free")}
      {renderArrow(t("smartSign.occupiedSymbol"), "occupied")}
      {/* <div>
        <label>State</label>

        <select
          value={state}
          onChange={function (e) {
            props.onStateChange(e.target.value);
          }}
        >
          <option value="free">Free</option>
          <option value="occupied">Occupied</option>
        </select>
      </div>

      <div>
        <label>Angle</label>

        <input
          type="number"
          value={config.angle}
          onChange={function (e) {
            update("angle", e.target.value);
          }}
        />
      </div>

      <div>
        <label>Color</label>

        <input
          type="color"
          value={config.color}
          onChange={function (e) {
            update("color", e.target.value);
          }}
        />
      </div> */}
    </div>
  );
});

const boxStyle = {
  border: "1px solid #ccc",
  padding: "10px",
  marginBottom: "15px",
  borderRadius: "6px",
};

const previewBox = {
  width: "140px",
  height: "140px",
  background: "#eee",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "6px",
};

export default SmartSignSettingsArrow;
